(function () {
  // Basic name -> hex map (add/edit as needed)
  const COLOR_MAP = {
    black: "#000000",
    grey: "#9e9e9e",
    gray: "#9e9e9e",
    white: "#ffffff",
    red: "#d32f2f",
    blue: "#1976d2",
    navy: "#0b1f3a",
    green: "#2e7d32",
    yellow: "#f9d423",
    orange: "#f57c00",
    purple: "#7b1fa2",
    pink: "#e91e63",
    brown: "#6d4c41",
    tan: "#d2b48c"
  };

  function toColor(token) {
    if (!token) return null;
    const t = token.trim().toLowerCase();
    // allow direct hex in option value if you ever want it, like #111111-#999999
    if (t.startsWith("#") && (t.length === 4 || t.length === 7)) return t;
    return COLOR_MAP[t] || null;
  }

  function applySplitSwatches(root) {
    // Try to find anything that looks like a swatch button/label and has a value
    // We look for common attributes used by themes: data-value, aria-label, title, or the input value nearby.
    const candidates = root.querySelectorAll(
      "[data-value], [data-option-value], [aria-label], [title]"
    );

    candidates.forEach((el) => {
      // Grab a likely value string
      const raw =
        el.getAttribute("data-value") ||
        el.getAttribute("data-option-value") ||
        el.getAttribute("aria-label") ||
        el.getAttribute("title") ||
        "";

      if (!raw) return;

      // Only run for values that look like "black-grey" or "black-red"
      // (You can change the separator if you prefer)
      const parts = raw.split("-").map(s => s.trim()).filter(Boolean);
      if (parts.length !== 2) return;

      const c1 = toColor(parts[0]);
      const c2 = toColor(parts[1]);
      if (!c1 || !c2) return;

      // Apply split background
      el.style.background = `linear-gradient(90deg, ${c1} 0 50%, ${c2} 50% 100%)`;

      // If the swatch has an inner element doing the background, try to set that too
      const inner = el.querySelector(".swatch, .swatch__color, .color-swatch, span");
      if (inner) inner.style.background = el.style.background;

      // Make borders look nice on light colors
      el.style.border = "1px solid rgba(0,0,0,0.15)";
      if (inner) inner.style.border = "1px solid rgba(0,0,0,0.15)";
    });
  }

  function init() {
    applySplitSwatches(document);

    // Re-apply when variants re-render (many themes update DOM)
    const obs = new MutationObserver(() => applySplitSwatches(document));
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
